import { Popup } from 'vant'
export default {
	components: {
		[Popup.name]: Popup,
	},
	props: {
		value: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		showPopup: {
			get() {
				return this.value
			},
			set(val) {
				this.$emit('input', val)
			},
		}
	},
	render() {
		return <van-popup v-model={this.showPopup} round close-on-click-overlay={false}>
			{this.renderContent}
		</van-popup>
	},
}